import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import { LiveInput, InputRow } from './inputsDemoHelpers';

function InputsTextDemoComponent() {
  return (
    <div>
      <InputRow label='Text — single line'>
        <LiveInput
          type={InputTypesEnum.Text}
          fieldName='demoText'
          labelText='Company name'
          placeholder='Type here…'
        />
      </InputRow>
      <InputRow label='TextList — comma list with an Import list box (paste from Excel)'>
        <LiveInput
          type={InputTypesEnum.TextList}
          fieldName='demoTextList'
          labelText='TP Job IDs'
          placeholder='e.g. 111,112,113'
        />
      </InputRow>
      <InputRow label='TextReadOnly — value, no editable control'>
        <LiveInput
          type={InputTypesEnum.TextReadOnly}
          fieldName='demoTextRo'
          labelText='Reference'
          initialValue='CD-5241'
        />
      </InputRow>
      <InputRow label='Number — integer with −/+ stepper (int)'>
        <LiveInput
          type={InputTypesEnum.Number}
          fieldName='demoNumber'
          labelText='Evaluators'
          placeholder='0'
        />
      </InputRow>
      <InputRow label='NumberWithoutSteppers — typed integer, no −/+ (ids, codes)'>
        <LiveInput
          type={InputTypesEnum.NumberWithoutSteppers}
          fieldName='demoNumberPlain'
          labelText='Apollo Manager Id'
          placeholder='e.g. 4271'
        />
      </InputRow>
      <InputRow label='NumberWithTwoDecimalPlaces — real/decimal'>
        <LiveInput
          type={InputTypesEnum.NumberWithTwoDecimalPlaces}
          fieldName='demoDecimal'
          labelText='Fieldwork fee'
        />
      </InputRow>
      <InputRow label='TextBox — multi-line textarea (nvarchar)'>
        <LiveInput
          type={InputTypesEnum.TextBox}
          fieldName='demoTextBox'
          labelText='Instructions'
          placeholder='Longer free text…'
        />
      </InputRow>
      <InputRow label='Notes — read-only paragraph'>
        <LiveInput
          type={InputTypesEnum.Notes}
          fieldName='demoNotes'
          labelText='Notes'
          initialValue='Rendered as a static paragraph, not an editable field.'
        />
      </InputRow>
      <InputRow label='PhoneNumber'>
        <LiveInput
          type={InputTypesEnum.PhoneNumber}
          fieldName='demoPhone'
          labelText='Contact phone'
        />
      </InputRow>
      <InputRow label='IntToDateInputElement — int column shown as a date'>
        <LiveInput
          type={InputTypesEnum.IntToDateInputElement}
          fieldName='demoIntDate'
          labelText='Go-live'
        />
      </InputRow>
      <InputRow label='Link — value rendered as an anchor'>
        <LiveInput
          type={InputTypesEnum.Link}
          fieldName='demoLink'
          labelText='Template'
          initialValue='https://example.com/file.xlsx'
        />
      </InputRow>
      <InputRow label='PlaceHolder — reserved empty slot'>
        <LiveInput
          type={InputTypesEnum.PlaceHolder}
          fieldName='demoPlaceholder'
          labelText='Placeholder'
        />
      </InputRow>
    </div>
  );
}

export const inputsTextDemo = {
  id: 'inputs-text',
  title: 'Text & numeric',
  category: 'Inputs',
  importPath: 'src/Elements/InputComponents/InputWithClear.js (type=Text / Number / TextBox / …)',
  notes: [
    'Every field in the app renders through <InputWithClear type={InputTypesEnum.X} />, which wraps the control in label + eraser + error chrome. The type→field mapping lives in src/Elements/InputComponents/renderers/index.js.',
    'Text is <input type=text> (nvarchar); Number coerces to an integer (int); NumberWithTwoDecimalPlaces is a real/decimal field; TextBox is a multi-line textarea.',
    'NumberWithoutSteppers is the same integer field without the −/+ buttons — use it for typed identifiers (ids, codes) where stepping the value makes no sense.',
    'The “…2” variants (Text2, Number2, TextBox2, NumberWithTwoDecimalPlaces2) are the same fields rendered bare — no label/eraser/error chrome — via TYPES_RENDERED_WITHOUT_CHROME in inputTypeGroups.js. Use them inside a DataTable cell.',
    'ReadOnly variants (TextReadOnly, TextBoxReadOnly) show the value with no editable control and no eraser.',
    'TextList is a Text field for a comma-separated list (ids, postal codes). Its list button opens an Import list box to paste a column of Excel cells into; pasting several cells straight into the field works too. Either way the value becomes a,b,c — split on new lines, tabs, commas and semicolons (not spaces), trimmed and de-duplicated (importListHelper.ts).',
  ],
  snippet:
    "<InputWithClear\n  type={InputTypesEnum.Number}\n  fieldName='EvaluatorCount'\n  labelText='Evaluators'\n  value={value}\n  onChange={(fieldName, v) => setValue(v)}\n/>",
  render: InputsTextDemoComponent,
};
